import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { BODeclaration } from '../../../../models/BSi/BO-Declaration';
import { ClientContextService } from '../../../../services/ClientContextService';
import { UDTableService } from '../../../../services/UDTableService';

@Component({
  selector: 'app-declarationcheck',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppDeclarationCheck {
    title = 'DeclarationCheck';

    constructor(private clientContext: ClientContextService, @Inject(DOCUMENT) private document: Document, private udTableService: UDTableService, private cookieService: CookieService) {
        
    }

    ngOnInit(): void {

        // no cookie exists, continue with the checks
        if (this.cookieService.get("declaration") == "") {

            //make sure the user is logged in and not on the declaration page before starting to check declaration
            if (this.clientContext !== undefined && this.clientContext.GetLoggedInId() !== undefined &&
                !this.document.location.pathname.toLowerCase().includes("/home") &&
                !this.document.location.pathname.toLowerCase().includes("/sign_in.aspx") &&
                this.document.location.pathname.toLowerCase() !== '/imis/' &&
                this.document.location.pathname.toLowerCase() !== '/imis/firms' && this.document.location.pathname.toLowerCase() !== '/imis/firms/' &&
                this.document.location.pathname.toLowerCase() !== '/imis/firms_fr' && this.document.location.pathname.toLowerCase() !== '/imis/firms_fr/'
            ) {
                //check to see if they have already declared if they have redirect to landing page
                this.udTableService.FetchSingle('CBA_Declaration', this.clientContext.GetSelectedId(), BODeclaration)
                    .subscribe((declaration: BODeclaration) => {

                        if (declaration === undefined ||                     // no row exists, redirect
                            (declaration !== undefined && declaration.DECLARE === undefined) || // a row exists, but there is no value for DECLARE
                            (declaration !== undefined && declaration.DECLARE !== "1")) { //a row exists but the value in declare is not 1

                            //redirect
                            this.document.location.href = `${this.clientContext.GetWebSiteRoot()}`;
                        }

                    });
            }
        }
        
    }
}
